import { Component, OnInit } from '@angular/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';

@Component({
  selector: 'fgb-points-management-page',
  templateUrl: './points-management-page.component.html',
  styleUrls: ['./points-management-page.component.scss'],
})
export class PointsManagementPageComponent implements OnInit {
  screenType = ScreenType;
  constructor() {}

  ngOnInit() {}
}
